import { axios } from "../axios.instance";

export type UnblockUserRequest = {
  userId: string;
};

export type UnblockUserResponse = object;

export const unblockUser = async (body: UnblockUserRequest): Promise<UnblockUserResponse> => {
  const { data } = await axios.post(`/blocks/${body.userId}/unblock`);

  return data;
};
